import { GlobalState } from 'src/redux/store';

export const proposalSelector = (state: GlobalState) => state.proposal;

export const proposalStatusSelector = (state: GlobalState) => proposalSelector(state).status;
